import { Params } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Route } from '../store/cms/models/route';

export const generateRouteFromUrl = (url: string, platformId: Object): Route => {
    try {
        const isBrowser = isPlatformBrowser(platformId);
        const baseUrl = isBrowser ? window.location.origin : 'http://localhost';
        const urlObj = new URL(url, baseUrl);
        const urlParts = urlObj.pathname.split('/').filter(Boolean);

        // Convert URLSearchParams to a plain object
        const queryParams: Params = Object.fromEntries(urlObj.searchParams.entries());
        return {
            baseRoute: urlParts[0] || '',
            sectionRoute: urlParts[1] || '',
            pageRoute: urlParts[2] || '',
            queryParams,
        };
    } catch (err) {
        console.error('Unable to generate route from url ', err);
        return null;
    }
};
